import { render } from "./Close.svg?vue&type=template&id=552e7afc"
const script = {}
script.render = render

export default script